import React, { useEffect, useState } from "react";
import { Form, Input, Button, Row, Col, Card, Modal } from "antd";
import { LoginUser, LogoutUser } from "../../actions";
import { useDispatch, useSelector } from "react-redux";
import { NavLink, Link, useHistory } from "react-router-dom";
import { GlobalApiErrorHandler } from "../../shared/helpers";
import { AES } from "crypto-js";
import { InputBox, isBrowser } from "../../shared/custom-ant-d";
import { reqPostValidateCandidate, reqPostLogout } from "../../axios/api";

const layout = {
  labelCol: {
    span: 8,
  },
  wrapperCol: {
    span: 16,
  },
};
const tailLayout = {
  wrapperCol: {
    md: {
      offset: 8,
      span: 16,
    },
  },
};

const registerationLayout = {
  wrapperCol: {
    md: {
      span: 24,
    },
    xs: {
      span: 24,
    },
  },
};

export const Login = (props) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const Auth = useSelector((state) => state.Auth);

  const [loginLoading, setLoginLoading] = useState(false);
  const [registerLink, setRegisterLink] = useState({
    pathname: "/register",
  });

  const [redirectConfig, setRedirectConfig] = useState(null);
  const [loginErrorMessage, setLoginErrorMessage] = useState("");
  const [showModalFraud, setShowModalFraud] = useState(false);

  useEffect(() => {
    if (Auth.isLoggedIn) {
      return history.push("/profile");
    }
  }, [Auth.isLoggedIn]);

  useEffect(() => {
    if (
      history.location.state !== undefined &&
      history.location.state !== null
    ) {
      setRedirectConfig({
        pathname: history.location.state.prevPath,
        state: history.location.state,
        search: history.location.state.search,
      });

      setRegisterLink({
        pathname: "/register",
        state: history.location.state,
      });
    }
  }, []);

  const onFinish = (values) => {
    setLoginLoading(true);
    // §11.3: send the plaintext password over TLS; Careers.Web encrypts it server-side.
    submit(values, values.password);
  };

  const submit = (values, encryptedPass) => {
    var jsonData = {
      PersonalEmail: values.email,
      Password: encryptedPass,
    };

    var jsonStr = JSON.stringify(jsonData);

    reqPostValidateCandidate(jsonStr)
      .then((res) => {
        if (res.data.isSuccess) {
          doLogIn(res.data.candidateObj);
        } else {
          setLoginErrorMessage(res.data.errorMessage);
          setLoginLoading(false);
        }
      })
      .catch((err) => {
        console.log(err);
        setLoginLoading(false);
        forceLogout();
        GlobalApiErrorHandler({ errors: err.response.data.errors });
      });
  };

  const doLogIn = (candidate) => {
    const envrypted = AES.encrypt(
      JSON.stringify(candidate),
      "IQORCAREERS"
    ).toString();
    sessionStorage.setItem("candidate", envrypted);

    dispatch(
      LoginUser({
        candidateID: candidate.candidateID,
        personalEmail: candidate.personalEmail,
        firstName: candidate.firstName,
        middleName: candidate.middleName,
        lastName: candidate.lastName,
        currentTitle: "",
        currentCompany: "",
        primaryPhone: candidate.primaryPhone,
        secondaryPhone: candidate.secondaryPhone,
        preferedContactMethodID: candidate.preferedContactMethodID,
        homeAddress1: candidate.homeAddress1,
        homeAddress2: candidate.homeAddress2,
        homeAddress3: candidate.homeAddress3,
        city: candidate.city,
        province: "",
        stateID: candidate.stateID,
        zipCode: candidate.zipCode,
        countryID: candidate.countryID,
        countryName: candidate.countryName,
        candidateCoverLetterUniqueID: candidate.candidateCoverLetterUniqueID,
        candidateResumeUniqueID: candidate.candidateResumeUniqueID,
        candidateCoverLetterFileFriendlyName:
          candidate.candidateCoverLetterFileFriendlyName,
        candidateResumeFileFriendlyName:
          candidate.candidateResumeFileFriendlyName,
        candidateBirthCertificateUniqueID: candidate.candidateBirthCertUniqueID,
        candidateBirtCertificateFriendlyName:
          candidate.candidateBirthCertFileFriendlyName,
        candidateCXCUniqueID: candidate.candidateCXCUniqueID,
        candidateCXCFriendlyName: candidate.candidateCXCFileFriendlyName,
        highestLevelOfEducationID: candidate.highestLevelOfEducationID,
      })
    );

    setLoginLoading(false);

    if (redirectConfig) {
      return history.push(redirectConfig);
    } else {
      return history.push("/profile");
    }
  };

  const forceLogout = () => {
    dispatch(LogoutUser());
    sessionStorage.removeItem("candidate");
    reqPostLogout();
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  return (
    <>
      <Row justify="center">
        <Col sm={12}>
          <Card title="Career Opportunities: Sign In" className="iqor-header">
            <Form
              {...layout}
              name="login"
              className="label-left-align"
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
            >
              <Row>
                <Col>
                  <p>
                    <strong>Already have an account?</strong> <br />
                    Enter your email address and password.
                  </p>
                </Col>
              </Row>

              <Form.Item
                label="Email"
                name="email"
                rules={[
                  {
                    required: true,
                    message: "Please fill in your email!",
                  },
                  {
                    type: "email",
                    message: "Please input a valid email",
                  },
                ]}
              >
                {isBrowser ? (
                  <Input onChange={(e) => setLoginErrorMessage("")} />
                ) : (
                  <InputBox
                    type={"email"}
                    onChange={(e) => setLoginErrorMessage("")}
                  />
                )}
              </Form.Item>

              <Form.Item
                label="Password"
                name="password"
                rules={[
                  {
                    required: true,
                    message: "Please input your password!",
                  },
                ]}
              >
                {isBrowser ? (
                  <Input.Password />
                ) : (
                  <InputBox type={"password"} />
                )}
              </Form.Item>

              {loginErrorMessage && (
                <>
                  <Row className="force-error-message">
                    <Col
                      md={{
                        span: layout.wrapperCol.span,
                        offset: layout.labelCol.span,
                      }}
                      xs={24}
                    >
                      <div className="ant-form-item-explain ant-form-item-explain-error">
                        <div role="alert">{loginErrorMessage}</div>
                      </div>
                    </Col>
                  </Row>
                </>
              )}

              <Form.Item {...tailLayout}>
                <Button
                  type="danger"
                  className="expand-on-mobile"
                  loading={loginLoading}
                  htmlType="submit"
                >
                  Sign In
                </Button>{" "}
                <NavLink
                  tag={Link}
                  className="forgot-password"
                  to="/forgot-password"
                >
                  Forgot your password?
                </NavLink>
              </Form.Item>

              <Form.Item {...registerationLayout} style={{ marginTop: "20px" }}>
                <strong>Not a registered user yet?</strong> <br />
                <NavLink tag={Link} className="" to={registerLink}>
                  Create an account
                </NavLink>{" "}
                to apply for our career opportunities.
              </Form.Item>
            </Form>
          </Card>
        </Col>
      </Row>
      <Row justify="center">
        <Col sm={12} style={{ fontSize: "13px", textAlign: "center", display: "none" }}>
          <p>Identifying and Avoiding Recruiting Scams and</p>
          <p>
            What to do if you are a Victim of Recruiting Fraud.{" "}
            <a href="#" onClick={() => setShowModalFraud(true)}>
              See More.
            </a>
          </p>
        </Col>
      </Row>
      <Modal
        title="Recruiting Fraud"
        visible={showModalFraud}
        onCancel={() => setShowModalFraud(false)}
        width={1000}
        bodyStyle={{ height: "70vh" }}
        footer={null}
      >
        <iframe src="./RecruitingFraud.html" width="100%" height="100%" />
      </Modal>
    </>
  );
};
